export default function ApartmentFeatures() {
  const features = [
    {
      icon: 'ri-home-5-line',
      title: '2 e 3 Quartos',
      description: 'Plantas inteligentes pensadas para seu conforto'
    },
    {
      icon: 'ri-ruler-line',
      title: 'A partir de 74m²',
      description: 'Espaços amplos e bem distribuídos'
    },
    {
      icon: 'ri-building-line',
      title: '15 Andares',
      description: 'Apenas 4 apartamentos por andar'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Padrão Construtivo',
      description: 'Acabamentos e materiais premium'
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-sm tracking-[0.3em] uppercase mb-4 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
            Exclusividade
          </p>
          <h2 className="text-5xl lg:text-6xl font-normal text-gray-900 mb-6" style={{ fontFamily: 'DM Serif Display, serif' }}>
            Projetado Para Você
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Cada detalhe foi cuidadosamente pensado para proporcionar uma experiência única de moradia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group text-center p-8 rounded-lg bg-gray-50 hover:bg-amber-50 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-white shadow-md group-hover:shadow-lg transition-all duration-300">
                <i className={`${feature.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'DM Serif Display, serif' }}>
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
